import styled, { css } from 'styled-components';

export const StyledHeaderLogOutItem = styled.div`
    ${() =>
        css`
            color: #42555d;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 13px;

            cursor: pointer;
            & > span {
                padding-left: 32px;
                padding-right: 32px;
                font-size: 12px;
                font-weight: 500;
                margin-right: auto;
                font-family: Montserrat;
                &:hover {
                    font-weight: 600;
                }
            }
        `}
`;
